<template>
  <icon-triangle fill="#606266" :stroke-width="0"></icon-triangle>
</template>
<script>
export default {
  name: 'icon-triangle-solid',
}
</script>